export default __webpack_public_path__ + "static/media/antp_PNSV_2024_png-04.d301391d.png";